export const QTY_DISCOUNT_MIN = 3;
export const QTY_DISCOUNT_PCT = 10;

export function quantityDiscount(items) {
  const total = items.reduce(
    (sum, i) => sum + (i.quantity >= QTY_DISCOUNT_MIN ? i.price * i.quantity * (QTY_DISCOUNT_PCT / 100) : 0),
    0
  );
  return Math.round(total * 100) / 100;
}

export function saleDiscountAmount(subtotal, percent) {
  return Math.floor((Math.round(subtotal * 100) * percent + 50) / 100) / 100;
}

export function resolveCartDiscount({ items, subtotal, coupon, sale }) {
  const qty = quantityDiscount(items);
  const couponAmount = coupon?.discount || 0;
  const saleAmount = sale?.active ? saleDiscountAmount(subtotal, sale.percent) : 0;
  if (saleAmount > 0 && saleAmount >= qty && saleAmount >= couponAmount) {
    return { discount: saleAmount, useSale: true, useQtyDiscount: false, label: `Summer Sale (${sale.percent}%)` };
  }
  if (qty > 0 && qty >= couponAmount) {
    return { discount: qty, useSale: false, useQtyDiscount: true, label: "Same-Product Quantity Discount (10%)" };
  }
  if (couponAmount > 0) {
    return { discount: couponAmount, useSale: false, useQtyDiscount: false, label: `Discount (${coupon.code})` };
  }
  return { discount: 0, useSale: false, useQtyDiscount: false, label: "Discount" };
}

export function orderDiscountLabel(order) {
  if (order.discount_type === "summer") return "Summer Sale (10%)";
  if (order.discount_type === "quantity") return "Same-Product Quantity Discount (10%)";
  if (order.coupon_code) return `Discount (${order.coupon_code})`;
  return "Discount";
}
